<template>
  <div class="submenuBar">
    <div class="submenuBar__wrapper">
      <span class="before"></span>
      <router-link v-for="(item, index) in listUrl" :key="index" class="submenuBar__item small-font" :to="{name: item.to}"> {{item.title}} </router-link>
      <span class="after"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'adx-submenu',
  props: {
    listUrl: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>